import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { Summary } from "./Summary.js";
const SummaryContainer = ({
  donationAmount,
  hasSubscription,
  isReadOnly,
  selectedPaymentMethodPrice
}) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    Summary,
    {
      summaryLabel: getLabel("cart.discount.summary"),
      selectedPaymentMethodPrice,
      isReadOnly,
      hasSubscription,
      donationAmount
    }
  );
};
export {
  SummaryContainer
};
//# sourceMappingURL=SummaryContainer.js.map
